export default "__VITE_ASSET__261bbce9__"